module.exports = __webpack_public_path__ + "prod/1.42.2/img/experience.2bf18c32.png";